<template>
  <v-dialog v-bind:value="dialog" @click:outside="$emit('close')" v-on:input="$emit('close')" max-width="1100px">
    <v-card>
      <v-form v-on:submit.prevent="importar($event)">
        <v-card-title>
          <span class="headline">{{ modal_title }}</span>
        </v-card-title>

        <v-card-text style="min-height: 450px">
          <v-stepper v-model="step" class="elevation-0">
            <v-stepper-header style="background: #607d8b; color: white">
              <v-stepper-step :complete="step > 1" step="1"> <span class="text-white">Paso 1</span> </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" step="2"> <span class="text-white">Paso 2</span> </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <div class="row justify-content-center">
                  <div class="col-md-6 pt-10">
                    <v-alert dense text type="info" class="fs-14">
                      Las cuentas se van a crear para el emisor <b>{{ emitter != null ? emitter.name : "-" }}</b
                      >.
                    </v-alert>

                    <p class="fs-16">1) Descargue el archivo excel para carga masiva</p>

                    <v-btn color="primary" class="mb-4 text-center ml-4" small @click="downloadTemplate">Descargar</v-btn>

                    <p class="fs-16">2) Complete el excel con las cuentas del plan de cuentas</p>
                    <p class="fs-16">3) Importe el excel con los datos completos</p>

                    <v-alert dense text type="warning" class="fs-14">
                      Si el <b>Grupo</b> se deja vacío se deriva del primer dígito del código. La <b>Cuenta Padre</b> se indica por código y debe existir o venir en el mismo archivo. Los códigos
                      repetidos se informan como error.
                    </v-alert>

                    <v-file-input
                      class="mt-3"
                      accept=".xlsx"
                      label="Seleccionar excel"
                      v-model="excel"
                      hint="Solo admite archivos formato .xlsx (No admite formato .xls)"
                      persistent-hint
                    ></v-file-input>

                    <v-btn color="primary" class="mt-3 float-right" small @click="readExcel" :disabled="excel == null || emitter == null">Siguiente</v-btn>
                  </div>
                </div>
              </v-stepper-content>

              <v-stepper-content step="2">
                <div style="border: solid 1px #999">
                  <v-data-table
                    :headers="headers"
                    :items="list_bulk"
                    :loading="loading"
                    :options="pagination"
                    loading-text="Cargando... Por favor espere"
                    :footer-props="{ 'items-per-page-options': [15, 50, 100, -1] }"
                    @pagination="updatePagination"
                  >
                    <template v-slot:item="{ item }">
                      <tr>
                        <td>{{ item.object.code }}</td>
                        <td>{{ item.object.name }}</td>
                        <td>{{ item.object.grupo_name ? item.object.grupo_name : "-" }}</td>
                        <td>{{ item.object.parent_code ? item.object.parent_code : "-" }}</td>
                        <td>{{ item.object.imputable ? "SI" : "NO" }}</td>
                        <td>{{ item.object.enabled ? "SI" : "NO" }}</td>
                        <td style="min-width: 200px" v-if="item.loading">Procesando...</td>
                        <td style="min-width: 200px" v-else-if="item.status == 0">Pendiente de procesado</td>
                        <td style="min-width: 200px" v-else-if="item.status_create"><span class="text-green">Importada</span></td>
                        <td style="min-width: 200px" v-else><span class="text-red">{{ item.msg }}</span></td>
                      </tr>
                    </template>

                    <template v-slot:no-data>
                      <v-alert :value="true" color="error" icon="warning" class="ma-2"> El archivo no contiene cuentas para importar. </v-alert>
                    </template>
                  </v-data-table>
                </div>

                <v-btn small class="text-white mt-3 mb-2" @click="step = step - 1" v-if="step != 1" color="red"> Atras </v-btn>

                <div class="pt-0 mt-3">
                  <p style="color: #1976d2; float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Cuentas pendientes de procesar: {{ getPendienteProcesar() }}</p>
                  <p class="text-green" style="float: left; margin-right: 30px; font-size: 16px; margin-bottom: 5px">Cuentas procesadas validas: {{ getProcesadosValidos() }}</p>
                  <p style="color: red; margin-bottom: 0px; font-size: 16px; margin-bottom: 5px">Cuentas procesadas invalidas: {{ getProcesadosNoValidos() }}</p>
                </div>

                <div class="row mt-1" v-if="loading_create">
                  <div class="col-md-12">
                    <v-progress-linear v-model="percent" color="blue-grey" style="height: 25px !important">
                      <strong>{{ Math.ceil(percent) }}%</strong>
                    </v-progress-linear>
                  </div>
                </div>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" text @click="$emit('close')">Cerrar</v-btn>
          <v-btn text color="green" type="submit" :loading="loading_create" :disabled="list_bulk.length == 0"> Importar </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import Constant from "@/constants/sections";
import { wsService } from "@/libs/ws/wsService";
import readXlsxFile from "read-excel-file";
import ModalGenericMixin from "@/mixins/ModalGenericMixin.vue";
import ExportMixin from "@/mixins/ExportMixin.vue";

export default {
  props: {
    modal_title: String,
    dialog: Boolean,
    emitter: Object,
  },
  mixins: [ModalGenericMixin, ExportMixin],
  data() {
    return {
      step: 1,
      list_bulk: [],
      headers: [
        { text: "Código", align: "left", sortable: false, value: "code" },
        { text: "Nombre", align: "left", sortable: false, value: "name" },
        { text: "Grupo", align: "left", sortable: false, value: "grupo_name" },
        { text: "Cuenta Padre", align: "left", sortable: false, value: "parent_code" },
        { text: "Imputable", align: "left", sortable: false, value: "imputable" },
        { text: "Habilitado", align: "left", sortable: false, value: "enabled" },
        { text: "Resultado", sortable: false, value: "msg" },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 15,
      },
      loading: false,
      excel: null,
      cuentas_creadas: 0,
      loading_create: false,
    };
  },
  computed: {
    percent: {
      get() {
        if (this.list_bulk.length == 0) return 0;
        return ((this.getProcesadosValidos() + this.getProcesadosNoValidos()) * 100) / this.list_bulk.length;
      },
      set(value) {
        return value;
      },
    },
  },
  watch: {
    dialog() {
      this.excel = null;
      this.loading_create = false;
      this.cuentas_creadas = 0;
      this.list_bulk = [];
      this.step = 1;
    },
  },
  methods: {
    getPendienteProcesar() {
      return this.list_bulk.filter((element) => element.status === 0).length;
    },
    getProcesadosValidos() {
      return this.list_bulk.filter((element) => element.status === 1 && element.status_create).length;
    },
    getProcesadosNoValidos() {
      return this.list_bulk.filter((element) => element.status === 1 && !element.status_create).length;
    },
    parseBoolean(value, default_value = true) {
      if (value === null || value === undefined || value.toString().trim() === "") return default_value;
      const parsed = value.toString().trim().toLowerCase();
      return parsed === "si" || parsed === "sí" || parsed === "1" || parsed === "true" || value === true;
    },
    parseObject(element) {
      return {
        code: element[0] != null ? element[0].toString().trim() : null,
        name: element[1] != null ? element[1].toString().trim() : null,
        grupo_name: element[2] != null ? element[2].toString().trim() : null,
        parent_code: element[3] != null ? element[3].toString().trim() : null,
        imputable: this.parseBoolean(element[4]),
        enabled: this.parseBoolean(element[5]),
        emitter: this.emitter,
      };
    },
    readExcel() {
      this.step++;
      this.list_bulk = [];
      this.cuentas_creadas = 0;

      readXlsxFile(this.excel, { sheet: 1 })
        .then((rows) => {
          const accounts = [];
          rows.forEach((element, index) => {
            if (index >= 1 && element[0] != null && element[1] != null) {
              accounts.push({
                object: this.parseObject(element),
                msg: "",
                status: 0,
                status_create: false,
                loading: false,
              });
            }
          });

          // Las cuentas padre deben crearse antes que sus hijas
          accounts.sort((a, b) => a.object.code.localeCompare(b.object.code, undefined, { numeric: true }));

          this.list_bulk = accounts;
        })
        .catch((error) => {
          console.log(error);
          this.$toast.error("Ocurrio un error al leer el archivo excel.", "Error");
        });
    },
    async importar() {
      this.loading_create = true;

      for (let index = 0; index < this.list_bulk.length; index++) {
        if (this.list_bulk[index].status != 0) continue;

        this.list_bulk[index].loading = true;
        const result = await this.createItem(this.list_bulk[index].object);

        this.list_bulk[index].loading = false;
        this.list_bulk[index].status = 1;
        this.list_bulk[index].status_create = result.status;
        this.list_bulk[index].msg = this.parseErrorResultValidation(result);
        if (result.status) this.cuentas_creadas++;
      }

      this.loading_create = false;

      const no_creadas = this.list_bulk.length - this.cuentas_creadas;
      if (no_creadas == 0) {
        this.$toast.success("Se crearon " + this.cuentas_creadas + " cuentas correctamente.", "Ok");
        this.$emit("close");
      } else {
        this.$toast.warning("Se crearon " + this.cuentas_creadas + " cuentas, pero " + no_creadas + " no se pudieron crear.", "Precaucion");
      }
      this.$emit("filter");
    },
    updatePagination(pagination) {
      this.pagination = pagination;
    },
    createItem(item) {
      return wsService.make_post_request(Constant.SECTION_ACCOUNTS + "/import-line-excel", item);
    },
    downloadTemplate() {
      this.exportExcel(Constant.SECTION_ACCOUNTS + "/get-sample-excel", {}, "plantilla_importacion_plan_de_cuentas.xlsx");
    },
  },
};
</script>
